// Copyright (c) 2017 Deere & Company

import AmountCellRenderer from '../../../reports/shared/report-cell-renderers/amount-cell-renderer';
import CityCellRenderer from '../components/city-cell-renderer';
import CountCellRenderer from '../../../reports/shared/report-cell-renderers/count-cell-renderer';
import LeadAccountCellRenderer from '../components/lead-account-cell-renderer';
import LinkToClaimsRenderer from '../components/link-to-claims-renderer';
import LinkedAmountRenderer from '../components/linked-amount-renderer';
import classNames from '../../../reports/shared/constants/ag-grid-class-names';
import {translate} from '../../../shared/services/translation-service';

export const getColumnDefinitions = params =>
    [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: LeadAccountCellRenderer,
            colId: 'leadAccount',
            field: 'leadAccount',
            filter: 'text',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LEAD_ACCOUNT'),
            queryParams: params,
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: CityCellRenderer,
            colId: 'city',
            field: 'city',
            filter: 'text',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            queryParams: params,
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'account',
            field: 'account',
            filter: 'text',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACCOUNT'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkToClaimsRenderer,
            colId: 'approvedClaimCount',
            field: 'approvedClaimCount',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('CLAIMS'),
            queryParams: params,
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: CountCellRenderer,
            colId: 'recoveryPercentage',
            field: 'recoveryPercentage',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('RECOVERED'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: CountCellRenderer,
            colId: 'recoveryWithoutAdditivesPercentage',
            field: 'recoveryWithoutAdditivesPercentage',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('RECOVERED_WITHOUT_ADDITIVES'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: CountCellRenderer,
            colId: 'recoveryWithMissedAdditivesPercentage',
            field: 'recoveryWithMissedAdditivesPercentage',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('RECOVERED_WITH_MISSED_ADDITIVES'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'totalApproved',
            field: 'totalApproved',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('TOTAL_APPROVED'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'totalApprovedWithoutAdditives',
            field: 'totalApprovedWithoutAdditives',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('TOTAL_APPROVED_WITHOUT_ADDITIVES'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'totalRequested',
            field: 'totalRequested',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('TOTAL_REQUESTED'),
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'totalUnpaid',
            field: 'totalUnpaid',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('TOTAL_UNPAID'),
            queryParams: params,
            unpaidFilter: 'totalUnpaid',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidParts',
            field: 'unpaidParts',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_PARTS'),
            queryParams: params,
            unpaidFilter: 'unpaidParts',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidPartsAdditive',
            field: 'unpaidPartsAdditive',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_PARTS_ADDITIVE'),
            queryParams: params,
            unpaidFilter: 'unpaidPartsAdditive',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidLabor',
            field: 'unpaidLabor',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_LABOR'),
            queryParams: params,
            unpaidFilter: 'unpaidLabor',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'pipsUnpaidLaborAdditives',
            field: 'pipsUnpaidLaborAdditives',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_LABOR_ADDITIVES_PIPS'),
            queryParams: params,
            unpaidFilter: 'unpaidLaborAdditivePips',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidLaborAdditivesExcludingPips',
            field: 'unpaidLaborAdditivesExcludingPips',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS'),
            queryParams: params,
            unpaidFilter: 'unpaidLaborAdditiveExcludingPips',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidTravel',
            field: 'unpaidTravel',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_TRAVEL'),
            queryParams: params,
            unpaidFilter: 'unpaidTravel',
            width: 150
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: LinkedAmountRenderer,
            colId: 'unpaidOtherCredits',
            field: 'unpaidOtherCredits',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('UNPAID_OTHER_CREDITS'),
            queryParams: params,
            unpaidFilter: 'unpaidOtherCredits',
            width: 150
        }
    ];



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/constants/column-definitions.js